import { BaseRebalancingQueryDto } from './base-rebalancing-query.dto';
import { Address } from '@31third/common';

export class RebalancingWalletQueryDto extends BaseRebalancingQueryDto {
  wallet: Address;
}
